var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentDefault28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 8.4C5.2 7.84772 4.75228 7.4 4.2 7.4H4C3.44772 7.4 3 7.84772 3 8.4V22.8C3 24.01 3.99 25 5.2 25H19.6C20.1523 25 20.6 24.5523 20.6 24V23.8C20.6 23.2477 20.1523 22.8 19.6 22.8H6.2C5.64772 22.8 5.2 22.3523 5.2 21.8V8.4ZM22.8 3H9.6C8.39 3 7.4 3.99 7.4 5.2V18.4C7.4 19.61 8.39 20.6 9.6 20.6H22.8C24.01 20.6 25 19.61 25 18.4V5.2C25 3.99 24.01 3 22.8 3ZM22.8 17.9C22.8 18.1761 22.5761 18.4 22.3 18.4H10.1C9.82386 18.4 9.6 18.1761 9.6 17.9V5.7C9.6 5.42386 9.82386 5.2 10.1 5.2H22.3C22.5761 5.2 22.8 5.42386 22.8 5.7V17.9ZM11.8 11.2C11.8 10.9239 12.0239 10.7 12.3 10.7H20.1C20.3761 10.7 20.6 10.9239 20.6 11.2V12.4C20.6 12.6761 20.3761 12.9 20.1 12.9H12.3C12.0239 12.9 11.8 12.6761 11.8 12.4V11.2ZM11.8 14.5C11.8 14.2239 12.0239 14 12.3 14H15.7C15.9761 14 16.2 14.2239 16.2 14.5V15.7C16.2 15.9761 15.9761 16.2 15.7 16.2H12.3C12.0239 16.2 11.8 15.9761 11.8 15.7V14.5ZM11.8 7.9C11.8 7.62386 12.0239 7.4 12.3 7.4H20.1C20.3761 7.4 20.6 7.62386 20.6 7.9V9.1C20.6 9.37614 20.3761 9.6 20.1 9.6H12.3C12.0239 9.6 11.8 9.37614 11.8 9.1V7.9Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDefault28);
export default __webpack_public_path__ + "static/media/content_default_28.66d70f9a7f1a83f31dece8bb2584b58f.svg";
export { ForwardRef as ReactComponent };